#import "../../../../editions/a-b-testing/graphql/fragments/comparison-edition-fragment.graphql"
#import "../../../../editions/a-b-testing/graphql/fragments/comparison-fragment.graphql"
#import "../../../graphql/fragments/campaign-fragment.graphql"

fragment BroadcastStubFragment on Campaign {
    id
    name
    htmlUrlPath
    deletedTime
    edition {
        id
        name
        htmlUrlPath
        viewInBrowserLink
        creatorUser {
            id
            name
        }
        createdTime
        modifiedTime
        deletedTime
        backgroundColor
        campaign {
            ...CampaignFragment
        }
        status
        emailTemplate {
            id
            thumbnailUrl
            subject
            previewText
            modifiedTime
            beeBodyJson
        }
        engagementStats {
            totalSentCount
            openRate
            clickRate
            unsubscribeRate
            permanentBounceRate
        }
        sendTime
        scheduledTime
        isABTesting
        comparisonEdition {
            ...ComparisonEditionFragment
        }
        comparison {
            ...ComparisonFragment
        }
        audience {
            id
            name
        }
        from {
            id
            emailAddress {
                display
                formatted
            }
        }
    }
}
